<button *ngIf="visible" mat-icon-button
        disableRipple="true"
        class="se-ui-datagrid-button_box se-button-no-ripple"
        (click)="_onButtonClick($event)"
        >
    <mat-icon>{{icon}}</mat-icon>
</button>
